import { mediaActions } from "./media/actions";
import { desiredMediaState } from "./media/state";
import {
  chatPageDown,
  chatPageUp,
  chatScrollByArrowDown,
  chatScrollByArrowUp,
} from "./scrollChatState";
import { isActiveRoom } from "./useActiveRoomState";
import { settingModalState, viewState } from "./viewState";

let spaceStartMs: number = 0;
let isMicroControl = false;
let saveStateMicro = false;

const keyPresdoc = (e: KeyboardEvent) => {
  let typingInChat = false;
  if (viewState.rightBlockContent === "chat") {
    if (settingModalState.value) return;
    if (e.ctrlKey || e.metaKey) return;
    if (viewState.chatFocused) {
      if (e.code === "PageUp") {
        chatPageUp();
        return;
      } else if (e.code === "PageDown") {
        chatPageDown();
        return;
      } else if (e.code === "ArrowUp") {
        chatScrollByArrowUp();
        return;
      } else if (e.code === "ArrowDown") {
        chatScrollByArrowDown();
        return;
      }
    } else if (e.code === "Escape") viewState.emojiShow = false;
    const textarea = document.getElementById(
      "chat-text-area",
    ) as HTMLInputElement;
    if (e.target !== textarea) {
      if (textarea && e.code !== "Space") {
        textarea.focus();
        textarea.selectionStart = textarea.value.length;
        textarea.selectionEnd = textarea.value.length;
      }
    } else {
      typingInChat = true;
    }
  }
  if (
    !typingInChat &&
    e.code === "Space" &&
    isActiveRoom.value &&
    !isMicroControl
  ) {
    spaceStartMs = Date.now();
    isMicroControl = true;
    saveStateMicro = desiredMediaState.microEnabled;
    if (!desiredMediaState.microEnabled) {
      mediaActions.microOn();
    } else {
      mediaActions.microOff();
    }
  }
};

const keyUpdoc = (e: KeyboardEvent) => {
  if (e.code === "Space" && isMicroControl && isActiveRoom.value) {
    const elapsed = Date.now() - spaceStartMs;
    if(elapsed >= 500) {
      if(saveStateMicro) {
        mediaActions.microOn()
      } else {
        mediaActions.microOff()
      }
    }
    spaceStartMs = 0;
    saveStateMicro = false;
    isMicroControl = false;
  }
};

document.addEventListener("keydown", keyPresdoc);
document.addEventListener("keyup", keyUpdoc);

document.addEventListener("mouseup", () => {
  const active = document.activeElement;
  if(active && !isEditableEl(active)) {
    (active as HTMLElement)?.blur();
  }
});

function isEditableEl(el: Element) {
  if (el instanceof HTMLTextAreaElement) {
    return true;
  }

  if (el instanceof HTMLInputElement) {
    return ![
      "button",
      "radio",
      "submit",
      "reset",
      "file",
      "color",
    ].includes(el.type);
  }

  return el instanceof HTMLElement && el.isContentEditable;
}
